import React, { useState } from 'react';

export default function CategoryForm({ category, onSave, onCancel }) {
  const [name, setName] = useState(category?.name || '');
  const [type, setType] = useState(category?.type || 'expense');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ name, type });
  };

  return (
    <form className="card" onSubmit={handleSubmit}>
      <h3>{category ? 'Редактировать категорию' : 'Новая категория'}</h3>
      <div className="form-group">
        <label>Название</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
      </div>
      <div className="form-group">
        <label>Тип</label>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="expense">Расход</option>
          <option value="income">Доход</option>
        </select>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button type="submit">Сохранить</button>
        <button type="button" className="secondary" onClick={onCancel}>Отмена</button>
      </div>
    </form>
  );
}
